import dictionary from '@rexmas/rexmas-shared/lib/conf/dictionary/es';
import errors from '../../conf/constants/errors';
import { apiFetcher } from '../../utils/api/fetcher';
import { showError } from './errors';
import {
  logout as logoutAction, saveStudentAction,
} from '../actionCreators/session';

export const login = (
  username,
  password,
  path,
  errorCallBack = () => null,
  nextUrl = null,
) => (dispatch) => apiFetcher({
  apiPath: path,
  method: 'post',
  data: {
    username,
    password,
    ...(nextUrl ? { next_url: nextUrl } : {}),
  },
}).then((response) => response.data)
  .catch((error) => {
    if (error.response.data.detalle === 'disabled_user_account'
      || error.response.data.detalle === 'block_user_account'
      || error.response.data.detalle === 'user_services_login') {
      throw error;
    } else {
      const errorStatus = error.response && error.response.status;
      const errorDetail = error.response && error.response.data
          && error.response.data.detalle;
      let errorLog;
      if (error.response.data.detalle === 'ip_not_allowed') {
        [errorLog] = error.response.data.mensajes;
      } else {
        errorLog = (errors.login[errorDetail])
          .replace(':intentsLeft', error.response.data.intentos_faltantes);
      }
      dispatch(showError({
        devSource: 'loginAction',
        message: (errorStatus !== 404 && errorLog) || dictionary.errors.invalidDomain,
        title: dictionary.general.notice,
        devDetail: error,
      }));
      errorCallBack();
    }
  });

export const unlockUserAccount = (
  username,
  errorCallBack = () => null,
) => (dispatch) => apiFetcher({
  apiPath: 'unlock_user_account_path',
  method: 'post',
  data: { username },
}).then((response) => response.data)
  .catch((error) => {
    const errorStatus = error.response && error.response.status;
    const errorDetail = error.response && error.response.data
      && error.response.data.detalle;
    const errorLog = errors.unlock_user_account[errorDetail];
    dispatch(showError({
      devSource: 'unlockUserAccountAction',
      message: (errorStatus !== 404 && errorLog) || dictionary.errors.invalidDomain,
      title: dictionary.general.notice,
      devDetail: error,
    }));
    errorCallBack();
  });

export const resetUserAccount = (
  uidb64,
  token,
  errorCallBack = () => null,
) => (dispatch) => apiFetcher({
  apiPath: 'reset_user_account_path',
  method: 'post',
  data: {
    uidb64,
    token,
  },
}).then((response) => response.data)
  .catch((error) => {
    const errorStatus = error.response && error.response.status;
    const errorDetail = error.response && error.response.data
      && error.response.data.detalle;
    const errorLog = errors.reset_user_account[errorDetail];
    dispatch(showError({
      devSource: 'resetUserAccountAction',
      message: (errorStatus !== 404 && errorLog) || dictionary.errors.invalidDomain,
      title: dictionary.general.notice,
      devDetail: error,
    }));
    errorCallBack();
  });

export const resetPassword = (
  username,
  errorCallBack = () => null,
) => (dispatch) => apiFetcher({
  apiPath: 'reset_password_path',
  method: 'post',
  data: { username },
}).then((response) => response.data)
  .catch((error) => {
    const errorStatus = error.response && error.response.status;
    const errorDetail = error.response && error.response.data
      && error.response.data.detalle;
    const errorLog = errors.reset_password[errorDetail];
    if (errorStatus && errorStatus < 500) {
      dispatch(showError({
        devSource: 'resetPasswordAction',
        message: error.response && error.response.data && error.response.data.mensaje,
        title: dictionary.general.notice,
        devDetail: error,
      }));
    } else {
      dispatch(showError({
        devSource: 'resetPasswordAction',
        message: (errorStatus !== 404 && errorLog) || dictionary.errors.invalidDomain,
        title: dictionary.general.notice,
        devDetail: error,
      }));
    }
    errorCallBack();
  });

export const resetPasswordConfirm = (
  password,
  uidb64,
  token,
  errorCallBack = () => null,
) => (dispatch) => apiFetcher({
  apiPath: 'reset_password_confirm_path',
  method: 'post',
  data: {
    password,
    uidb64,
    token,
  },
}).then((response) => response.data)
  .catch((error) => {
    const status = error.response && error.response.status;
    const detail = error.response && error.response.data
      && error.response.data.detalle;
    const message = error.response && error.response.data
      && error.response.data.mensajes[0];
    const errorLog = errors.reset_password_confirm[detail];
    dispatch(showError({
      devSource: 'resetPasswordConfirmAction',
      message: message || (status !== 404 && errorLog) || dictionary.errors.invalidDomain,
      title: dictionary.general.notice,
      devDetail: error,
    }));
    errorCallBack();
  });

export const logout = () => (dispatch) => {
  dispatch(logoutAction());
};

export const saveStudent = () => (dispatch) => apiFetcher({
  apiPath: 'is_student_path',
  method: 'get',
})
  .then((response) => {
    dispatch(saveStudentAction(response.data.es_estudiante));
  })
  .catch(() => null);

export const showErrors = (error) => (dispatch) => {
  const errorStatus = 400;

  const errorLog = errors.reset_password_confirm[error];
  dispatch(showError({
    devSource: 'errorFormsPasswordConfirm',
    message: (errorStatus !== 404 && errorLog) || dictionary.errors.invalidDomain,
    title: dictionary.general.notice,
    devDetail: error,
  }));
};
